import type { DateRangeSelection } from './types'

import { parseLooseDate } from '@/shared/lib/date/parse'
import { toApiDate } from '@/shared/lib/date/toApiDate'
import type { DateRangeValue } from '@/shared/ui'

function parseDate(value: string | null): Date | null {
  if (!value) return null
  const parsed = parseLooseDate(value)
  return Number.isNaN(parsed.getTime()) ? null : parsed
}

export function selectionFromValue(
  value: DateRangeValue,
  savedAt = new Date().toISOString(),
): DateRangeSelection | null {
  if (!value.start || !value.end) return null
  return {
    startDate: toApiDate(value.start),
    endDate: toApiDate(value.end),
    compareEnabled: value.compareEnabled,
    compareStartDate: value.compareStart ? toApiDate(value.compareStart) : null,
    compareEndDate: value.compareEnd ? toApiDate(value.compareEnd) : null,
    activePresetKey: value.presetId,
    compareType: value.compareType,
    savedAt,
  }
}

export function valueFromSelection(selection: DateRangeSelection): DateRangeValue {
  return {
    start: parseDate(selection.startDate),
    end: parseDate(selection.endDate),
    presetId: selection.activePresetKey,
    compareEnabled: selection.compareEnabled,
    compareType: selection.compareType,
    compareStart: parseDate(selection.compareStartDate),
    compareEnd: parseDate(selection.compareEndDate),
  }
}

function clampDate(value: string, min: string | null, max: string | null): string {
  if (min && value < min) return min
  if (max && value > max) return max
  return value
}

export function clampSelection(
  selection: DateRangeSelection,
  bounds: { min: string | null; max: string | null },
): DateRangeSelection {
  const startDate = clampDate(selection.startDate, bounds.min, bounds.max)
  const endDate = clampDate(selection.endDate, bounds.min, bounds.max)
  return {
    ...selection,
    startDate: startDate <= endDate ? startDate : endDate,
    endDate: endDate >= startDate ? endDate : startDate,
  }
}
